// extracted by mini-css-extract-plugin
export default {"menu":"ColorMenu_menu__u6cDE","colorWrapper":"ColorMenu_colorWrapper__tqsSe","selected":"ColorMenu_selected__XFx42","colorBox":"ColorMenu_colorBox__uoWm5"};